import React, { HTMLAttributes } from 'react';
import c from 'classnames';
import s from './FooterRowLayout.scss';

interface Props extends Omit<HTMLAttributes<HTMLDivElement>, 'children'> {
  blocks: React.ReactNode[];
}

const FooterRowLayout: React.FC<Props> = ({ blocks, className, ...rest }) => (
  <div className={c(s['root'], className)} {...rest}>
    {blocks}
  </div>
);
FooterRowLayout.displayName = 'FooterRowLayout';

export default FooterRowLayout;
